import React, {Component} from 'react';
import {connect} from 'react-redux';
import {RouteWithSubRoutes} from '../../utils/router-utils';
import {Redirect, Switch} from 'react-router-dom';
import {getToken} from '../../utils/local-storage';
import {bindActionCreators} from 'redux';
import * as userActions from '../../actions/user-actions';

class AppContainer extends Component {

    componentWillMount() {
        if (getToken()) {
            this.props.actions.getCurrentUser();
        }
    }

    render() {
        return (<div><Switch>
            {this.props.routes.map((route, i) => (<RouteWithSubRoutes key={i} {...route}/>))}
            <Redirect to="/app/games"/>
        </Switch></div>);
    }
}

export default connect((state) => {
    return {
        user: state.user.currentUser,
    };
}, (dispatch) => {
    return {
        actions: bindActionCreators({
            ...userActions
        }, dispatch),
        dispatch
    };
})(AppContainer);



// WEBPACK FOOTER //
// ./src/js/routes/app/app-container.jsx